import React from "react";
import useOutsideClick from "../hooks/useOutsideClick";
import GTM from "../GTM";
import PropTypes from "prop-types";

const MAX_DROPDOWN_HEIGHT = 320;

function OrganizationAutocompleteDropdown({
    organizations,
    hideOrganizationAutocompleteDropdown,
    organizationInputRef,
    selectOrganization,
}) {
    const dropdownRef = React.useRef(null);
    const dropdownOutsideClick = useOutsideClick(
        dropdownRef,
        organizationInputRef
    );
    const gtm = new GTM(null);
    React.useEffect(() => {
        if (dropdownOutsideClick === true)
            hideOrganizationAutocompleteDropdown();
    }, [dropdownOutsideClick]);
    const url = window.location.pathname;

    return (
        <div ref={dropdownRef}>
            <div
                className="search-dropdown custom-scrollbar"
                style={{
                    display: organizations.length === 0 ? "none" : "block",
                    maxHeight: MAX_DROPDOWN_HEIGHT,
                    overflowY: "auto",
                }}
            >
                <div
                    className="custom-scrollbar-css"
                    id="org-list"
                    role="listbox"
                    aria-live="off"
                >
                    {organizations.map((value) => (
                        <a
                            key={value.ORGANIZATIONID}
                            id={`org-item-${value.ORGANIZATIONID}`}
                            role="option"
                            onClick={(e) => {
                                e.preventDefault();
                                selectOrganization(value);
                                gtm.Event(
                                    "search",
                                    "textbox",
                                    "interact",
                                    `${value.ORGNIZATIONNAME.toLowerCase()}`,
                                    "search",
                                    "",
                                    "field_interaction",
                                    url === "/preferences"
                                        ? ""
                                        : `${value.ORGNIZATIONNAME.toLowerCase()}`
                                );
                            }}
                            tabIndex="0"
                            className="organisationclass"
                            onKeyUp={(e) => {
                                if (e.key === "ArrowDown") {
                                    let control =
                                        e.currentTarget.nextElementSibling;
                                    control?.focus();
                                }
                                if (e.key === "ArrowUp") {
                                    let control =
                                        e.currentTarget.previousElementSibling;
                                    control?.focus();
                                }
                                if (e.key === "Enter")
                                    selectOrganization(value);
                            }}
                        >
                            {value.ORGNIZATIONNAME}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}

OrganizationAutocompleteDropdown.propTypes = {
    organizations: PropTypes.arrayOf(
        PropTypes.shape({
            ORGANIZATIONID: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            ORGNIZATIONNAME: PropTypes.string.isRequired,
            ORGANIZATIONGROUPID: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.oneOf([null]),
            ]),
            ORGANIZATIONGROUPNAME: PropTypes.string,
            ORGANIZATIONIDISF: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
        })
    ).isRequired,
    hideOrganizationAutocompleteDropdown: PropTypes.func.isRequired,
    organizationInputRef: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }).isRequired,
    selectOrganization: PropTypes.func.isRequired,
};

export default OrganizationAutocompleteDropdown;
